import request from './request'

/**
 * 请求API
 * 按业务类型划分模块，即1个业务类型封装1个模块
 * 为了接口字段明确，接口要显示写出来
 */


// 查询好物的所有sku信息
export const getSku = ({ goodsNo }) => {
  return request('/operation-freemall/ws/v1/goods/sku', { goodsNo })
}

// 获取好物类别
export const getListCategory = ({ pageNo, pageSize }) => {
  return request('/operation-freemall/ws/v1/category', { pageNo, pageSize })
}

// 获取好物详情
export const getDetail = ({ goodsNo }) => {
  return request('/operation-freemall/ws/v1/goods/detail', { goodsNo })
}

// 获取某个类别下的好物
export const getCategory = ({ categoryCode, pageNo, pageSize }) => {
  return request('/operation-freemall/ws/v1/goods/category', { categoryCode, pageNo, pageSize })
}

// 首页获取热门好物
export const getHotGoods = ({ number }) => {
  return request('/operation-freemall/ws/v1/goods/hot', { number })
}

// 首页获取好物类别包括好物
export const getIndexHotGoods = ({ numberOfGoods, pageNo, pageSize }) => {
  return request('/operation-freemall/ws/v1/category/goods', { numberOfGoods, pageNo, pageSize })
}



// WEBPACK FOOTER //
// ./src/services/goods.js